<template>
  <VueDatetime
    v-on="$listeners"
    v-bind="$attrs"
    class="base-datetime"
    :phrases="{ok: 'Næste', cancel: 'Afslut'}"
    input-class="base-input"
    type="datetime"
    format="dd/MM/yyyy HH:mm"
  />
</template>

<script>
import { Datetime as VueDatetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { Settings } from 'luxon';


export default {
    name: 'BaseDatetimePicker',
    components: { VueDatetime },
    created() {
        Settings.defaultLocale = 'da';
    },
};
</script>

<style lang="scss" scoped>
.base-datetime {
    width: 100%;
}
</style>
